import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { useGetOrderDetails } from '@/hooks/order/useGetOrderDetails';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { initialState } from './OrderDetailUi';
import { orderDetailsResponseToOrderDetailUi } from './mapper';

export function useOrderDetailViewController() {
  const [uiState, setUiState] = useImmer(initialState);
  const { showSnackError } = useSnackbarContext();
  const orderDetailId = useParams().orderDetailId ?? '';
  const { data, error } = useGetOrderDetails(orderDetailId);
  const { session } = useGlobalContext();

  useEffect(() => {
    if (!data || !session?.type) return;
    setUiState(orderDetailsResponseToOrderDetailUi(data, session));
  }, [data, session]);

  useEffect(() => {
    if (!error) return;
    showSnackError('Error al obtener los detalles de la orden');
  }, [error]);

  return {
    uiState: {
      ...uiState,
      showNavigationTabs: uiState.navTabs.length > 0,
    },
  };
}
